/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { platform } from 'network-utils';

const awsApi = platform.learningPanel.AwsAPIs;

export const getUserProfilePictureKey = 'get-user-profile-picture';
export const getUsersProfilePicturesKey = 'get-users-profile-pictures';

export const useGetUserProfilePicture: any = (userUuid: string) => {
    return useQuery([getUserProfilePictureKey, userUuid], () => awsApi.getUserProfilePicture(), {
        enabled: !!userUuid,
        staleTime: Infinity
    });
};
